/**************************************************
 * Nombre:       Home_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Testimonio from "../../Tarjetas/Tarjeta_Testimonio";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import hombreuno from '../../../Recursos/hombreuno.png'
import hombredos from '../../../Recursos/hombredos.png'
import mujeruno from '../../../Recursos/mujeruno.png'
import mujerdos from '../../../Recursos/mujerdos.png'
import mujertres from '../../../Recursos/mujertres.png'

const Home_Testimonios = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#D9D9D9'}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', pt: 8}}>
                    <Typography sx={{fontSize: 32, fontWeight: 800}}>
                        Lo que dicen de nosotros
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6, pb: 10}}>
                    <Splide
                        //ref={refe}
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: sCell ? 1 : 3,
                            arrows: true,
                            perMove: 1,
                            pagination: true,
                            width: '100%',
                            drag: 'free',
                            snap: true,
                            interval: 5000,
                            noDrag: true,
                            focus: 'center',
                            type: 'loop',
                            padding: sCell ? 0 : '5rem',
                            gap: sCell ? 10 : 50,

                        }}
                    >

                        {items.map((item, index) => {
                            return (
                                <SplideSlide key={`qer${index}`}>
                                    <Tarjeta_Testimonio item={item}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Testimonios

const items = [
    {
        frase: 'Ahorrar aquí cambió mi manera de ver el futuro.',
        descripcion: 'Gracias a Esperanza Hispana aprendí que cada pequeño ahorro tiene un propósito. Hoy no solo tengo estabilidad, también la tranquilidad de saber que mi esfuerzo está protegido y creciendo',
        nombre: 'Laura T. Gómez',
        profesion: 'Enfermera',
        img: mujeruno
    },
    {
        frase: 'Nunca imaginé que ahorrar me daría tanta seguridad.',
        descripcion: 'Con Esperanza Hispana no solo guardo mi dinero, lo hago rendir. Además, saber que tengo un seguro de vida me da confianza para seguir trabajando por los sueños de mi familia.',
        nombre: 'Andrés A. Pineda',
        profesion: 'Conductor de reparto',
        img: hombreuno
    }
    ,
    {
        frase: 'Mi ahorro se convirtió en una herramienta de esperanza.',
        descripcion: 'Antes no sabía cómo manejar mis finanzas, pero aquí encontré orientación y una comunidad que me motiva. Ahora tengo metas claras y sé que puedo cumplirlas paso a paso.',
        nombre: 'Carolina Rojas',
        profesion: 'Docente',
        img: mujerdos
    }
    ,
    {
        frase: 'Ahorrar nunca había sido tan fácil ni tan significativo.',
        descripcion: 'Desde que me uní a Esperanza Hispana, aprendí a organizarme y a ver resultados. Mis ahorros crecen, tengo respaldo y me siento acompañado en todo momento.',
        nombre: 'Julián E. Torres',
        profesion: 'Chef',
        img: hombredos
    }
    ,
    {
        frase: 'Hoy ahorro con propósito y confianza.',
        descripcion: 'En Esperanza Hispana encontré más que una plataforma, encontré guía y protección. Mis ahorros están seguros y cada día me acerco más a cumplir mis metas.',
        nombre: 'Diana E. Castillo',
        profesion: 'Docente',
        img: mujertres
    }
]